import React from "react";
import MouseParticles from 'react-mouse-particles';
import DisplayPic from "../../Images/me.jpg";
import DisplayPicSmallScreen from "../../Images/MeSmallScreen.jpg"
import Bubbles from "../../Images/bubbles.png"
import { 
    HeroContainer, 
    HeroBackground, 
    HeroP,
    HeroSubTitle,
    HeroH1,
    HeroContent,
    BubblesDiv,
    BubbleImg,
    ProfilePic,
    HandlingHero
   } from "./HeroElements"
   //"https://i.ibb.co/dcyGRL6/bubbles.png"
const HeroSection = () => {
    return (
        <HeroContainer id = "home">
            <HeroBackground>
            <BubblesDiv>
            <BubbleImg src={Bubbles} alt=""/>
            </BubblesDiv>
            <MouseParticles g={1} color="random" cull="col,image-wrapper"/>
            </HeroBackground>
            <HandlingHero>
            <ProfilePic src = {window.screen.width > 760 ? DisplayPic : DisplayPicSmallScreen} alt = "Kiran"/>
                <HeroContent>
                    <HeroH1>
                        Kiran R
                    </HeroH1>
                    <HeroSubTitle>
                        FULL STACK WEB DEVELOPER
                    </HeroSubTitle>
                    <HeroP>
                    A compassionate individual with a problem
                    solving mindset to deliver top-notch solutions
                    through diligent efforts combined with high
                    degree of integrity with every collaborator.
                    </HeroP>
                </HeroContent>
            </HandlingHero>
        </HeroContainer>
    )
}

export default HeroSection;